module.exports = __webpack_public_path__ + "media/images/share-fb-55b4b83f2d5a55d66d98ab636376f829.svg";